import { useCallback } from 'react';

import { DEFAULT_PRODUCT_QUANTITY } from '@utils/constant';
import { bopisThresholdCalculate } from '@utils/utility';

/** @param {Object} data
 * @param {String} data.productId
 * @param {String} data.variantId
 * @param {String} data.BOPISThreshold
 * @param {String} data.lineQuantity*/
export const mappingProductsListPayload = (data) => (
  {
    ProductId: data.productId,
    VariantId: data.variantId,
    Threshold: bopisThresholdCalculate({
      currentThreshold: data.BOPISThreshold ?? 0,
      lineQuantity: data.lineQuantity ?? DEFAULT_PRODUCT_QUANTITY
    })
  }
);

const useMappingProductsList = () => {
  return useCallback(
    /** @param {Array} productsListPayload*/
    (productsListPayload) => {
      /** INFO: init productsList with the data equal to productsListPayload length */
      let productsList = productsListPayload.map(() => (
        []
      ));

      if (!productsListPayload?.every(item => item?.['Active Variant']?.active)) {
        for (const [index, productItem] of [...productsListPayload].entries()) {
          if (productItem['Active Variant']?.active) {
            productsList[index] = [
              ...productsList[index], {
                ...mappingProductsListPayload({
                  productId: productItem.ProductId,
                  variantId: productItem['Active Variant'].VariantId,
                  BOPISThreshold: productItem.Stock?.BOPISThreshold,
                  lineQuantity: DEFAULT_PRODUCT_QUANTITY
                })
              }
            ];
          } else {
            if (productItem.Variants?.length) {
              productItem.Variants.forEach((variant) =>
                productsList[index] = [
                  ...productsList[index], {
                    ...mappingProductsListPayload({
                      productId: productItem.ProductId,
                      variantId: variant.VariantId,
                      BOPISThreshold: variant.Stock?.BOPISThreshold,
                      lineQuantity: DEFAULT_PRODUCT_QUANTITY
                    })
                  }
                ]
              );
            }
          }
        }
      } else {
        productsList =
          [
            productsListPayload.map((productItem) => (
              {
                ...mappingProductsListPayload({
                  productId: productItem['Active Variant']?.ProductId,
                  variantId: productItem['Active Variant']?.VariantId,
                  BOPISThreshold: productItem['Active Variant']?.Stock?.BOPISThreshold,
                  lineQuantity: DEFAULT_PRODUCT_QUANTITY
                })
              }
            ))
          ];
      }

      return productsList;
    }, []);
};

export default useMappingProductsList;